<div class="container">
  <div class="table-header">
    <div class="table-title">
      <div class="table-icon">
        <i nz-icon nzType="sliders"></i>
      </div>
      <div class="table-name">
        <span>Precedence</span>
      </div>
    </div>
    <div class="table-action-controls">
      <div class="table-action-filter">
        <nz-input-group [nzPrefix]="prefixIconSearch" [nzSuffix]="SuffixIconSearch">
          <input
            (input)="onSearch($event)"
            nz-input
            placeholder="Search"
            style="width: 300px"
            type="text"
          />
        </nz-input-group>
        <ng-template #prefixIconSearch>
          <i nz-icon nzType="search"></i>
        </ng-template>
        <ng-template #SuffixIconSearch>
          <i
            nz-icon
            nzType="table"
            (click)="toggleColumnFilters()"
            [ngClass]="{ 'ant-filter-active': showColumnFilters }"
            style="cursor: pointer"
          ></i>
        </ng-template>
      </div>
      <div class="table-action-create">
        <button (click)="openmodal()" nz-button nzType="primary" style="font-weight: 500">
          <b><span nz-icon nzType="plus" style="font-weight: 500"> </span></b>New
        </button>
      </div>
      <div class="table-action-refresh">
        <button (click)="getPrecedence()" nz-button><span nz-icon nzType="sync"></span></button>
      </div>
      <div class="table-action-settings">
        <button nz-button><span nz-icon nzType="setting"></span></button>
      </div>
      <div class="table-action-dropdown">
        <button nz-button><span nz-icon nzType="menu"></span></button>
      </div>
    </div>
  </div>
</div>

<div class="table-body">
  <nz-table
    #basicTable
    [nzData]="filteredData"
    [nzScroll]="{ y: tableHeight + 'px' }"
    [nzShowPagination]="false"
    nzSize="small"
    style="border: solid 1px #e6e6e6; border-bottom: none"
  >
    <thead style="padding: 5px">
      <tr>
        <th [nzSortFn]="sortSuperseded" nzShowSort nzWidth="40%" style="color: #777">
          Superseded SOP Input
        </th>
        <th [nzSortFn]="sortSuperseding" nzShowSort nzWidth="40%" style="color: #777">
          Superseding SOP Input
        </th>
        <th nzWidth="20%"></th>
      </tr>
      <tr *ngIf="showColumnFilters">
        <th>
          <input
            nz-input
            (input)="updateColumnFilter('superseded', $event)"
            [value]="columnFilters['superseded'] || ''"
            placeholder="Filter superseded..."
          />
        </th>
        <th>
          <input
            nz-input
            (input)="updateColumnFilter('superseding', $event)"
            [value]="columnFilters['superseding'] || ''"
            placeholder="Filter superseding..."
          />
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of filteredData">
        <td style="border-bottom: none">
          <a (click)="editPrecedence(item.id)">{{ item.superseded }}</a>
        </td>
        <td style="border-bottom: none">{{ item.superseding }}</td>
        <td style="border-bottom: none">
          <div class="action-button">
            <i (click)="editPrecedence(item.id)" nz-icon nzType="edit"></i>
            <i
              (nzOnConfirm)="deletePrecedence(item.id)"
              nz-icon
              nz-popconfirm
              nzCancelText="Cancel"
              nzOkText="Yes"
              nzOkType="primary"
              nzPopconfirmPlacement="bottom"
              nzPopconfirmTitle="Are you sure to delete?"
              nzType="delete"
            ></i>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <div *ngIf="!filteredData?.length" style="padding: 20px; text-align: center; color: #999;">
    No data to display!
  </div>
</div>

<div class="footer">
  <div class="data-count" style="margin-left: 10px">
    {{ filteredData?.length || 0 }} Records
  </div>
</div>

<nz-modal
  (nzOnCancel)="handleCancel()"
  [(nzVisible)]="isVisible"
  [nzFooter]="modalFooter"
  [nzOkLoading]="isOkLoading"
  [nzTitle]="isEditMode ? 'Edit Precedence Rule' : 'Add Precedence Rule'"
  nzWidth="70%"
>
  <form [formGroup]="precedenceForm">
    <div *nzModalContent class="precedenceForm">
      <div nz-row [nzGutter]="16">
        <div nz-col [nzSpan]="12">
          <nz-form-item nzLayout="horizontal">
            <nz-form-label nzRequired [nzSpan]="10">Superseded SOP Input</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <nz-select
              formControlName="supersededSopInputId"
              nzShowSearch
              nzAllowClear
              nzSize="small"
              style="width: 100%"
              (nzChange)="onSupersededChange($event)"
            >
              <nz-option
                *ngFor="let input of sopInputs"
                [nzLabel]="input.title"
                [nzValue]="input.id"
              ></nz-option>
            </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="12">
          <nz-form-item nzLayout="horizontal">
            <nz-form-label nzRequired [nzSpan]="10">Superseding SOP Input</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <nz-select
              formControlName="supersedingSopInputId"
              nzShowSearch
              nzAllowClear
              nzSize="small"
              style="width: 100%"
              (nzChange)="onSupersedingChange($event)"
            >
              <nz-option
                *ngFor="let input of sopInputs"
                [nzLabel]="input.title"
                [nzValue]="input.id"
              ></nz-option>
            </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>
  </form>
</nz-modal>

<ng-template #modalFooter>
  <div style="display: flex; justify-content: flex-end; gap: 5px; padding: 5px">
    <button (click)="handleSave()" nz-button nzType="primary" [nzLoading]="isOkLoading" [disabled]="isSaveDisabled">
      <i nz-icon nzType="save" style="margin-right: 5px"></i> Save
    </button>
    <button (click)="handleCancel()" nz-button nzType="default" [disabled]="isOkLoading">Cancel</button>
  </div>
</ng-template>